module.exports = __webpack_public_path__ + "img/round-table-dark.5342e375.svg";